(() => {
  const styleId = 'lm-clarity-warm-beige';
  const css = `
    #root [role="dialog"] {
      --background-1: #EDE5DA;
      --color-background-1: #EDE5DA;
      --background-1-hover: #E4DACD;
      --color-background-1-hover: #E4DACD;
      --foreground-1: #323232;
      --color-foreground-1: #323232;
      --foreground-2: #454545;
      --color-foreground-2: #454545;
      --foreground-4: #5B534A;
      --color-foreground-4: #5B534A;
      background-color: #EDE5DA !important;
      color: #323232;
    }
    /* lm-clarity-readable-links: keep links legible on the warm beige chat background. */
    #root [role="dialog"] a[href],
    #root [role="dialog"] [role="link"] {
      color: #3B2F2F !important;
      text-decoration: underline !important;
      text-decoration-color: #8B7355 !important;
      text-underline-offset: 2px;
    }
    #root [role="dialog"] a[href]:hover,
    #root [role="dialog"] [role="link"]:hover {
      color: #5B4430 !important;
    }
    #root [role="dialog"] a[href]:focus-visible,
    #root [role="dialog"] [role="link"]:focus-visible {
      outline: 2px solid #8B7355;
      outline-offset: 2px;
    }
    #root [role="dialog"] h1,
    #root [role="dialog"] h2,
    #root [role="dialog"] h3 {
      color: #3B2F2F !important;
    }
    #root [role="dialog"] .composer-edge-gradient {
      background-image: linear-gradient(to top, #EDE5DA 0%, #EDE5DA 55%, transparent 100%) !important;
    }
    #root [role="dialog"] [data-testid="chat-composer"] {
      background-color: #F5F0E8 !important;
    }
  `;
  let root;
  let rootObserver;
  let pending = false;
  let retry;
  let retryUntil = 0;
  let waitingHost;

  const ensureStyle = () => {
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.append(style);
  };

  const attach = () => {
    pending = false;
    window.clearTimeout(retry);
    const host = document.getElementById('ads-agent-host');
    if (!host) return;
    if (!host.shadowRoot) {
      if (host !== waitingHost) {
        waitingHost = host;
        retryUntil = Date.now() + 20000;
      }
      if (Date.now() < retryUntil) retry = window.setTimeout(attach, 250);
      return;
    }
    if (root !== host.shadowRoot) {
      rootObserver?.disconnect();
      root = host.shadowRoot;
      rootObserver = new MutationObserver(ensureStyle);
      rootObserver.observe(root, { childList: true });
    }
    ensureStyle();
  };

  const observer = new MutationObserver(() => {
    const host = document.getElementById('ads-agent-host');
    if (pending || (!host && !root) || (host?.shadowRoot && host.shadowRoot === root)) return;
    pending = true;
    window.requestAnimationFrame(attach);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  attach();
})();
